import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import GlobalSearch from "./pages/GlobalSearch";
import LoginPage from "./pages/LoginPage";
import WatchlistEvents from "./pages/WatchlistEvents";
import Watchlists from "./pages/Watchlists";
import Recover from "./pages/Recover";
import Register from "./pages/Signup";
import Organizations from "./pages/Organizations";
import Profile from "./pages/Profile";
import IntelPosts from "./pages/ThreadFeeds";
import ContactPanel from "./pages/Contact";
import Upgrades from "./pages/Upgrades";
import Webhooks from "./pages/Webhooks";
import ProtectedRoute from "./components/ProtectedRoute";
import SavedIncidents from "./pages/SavedIncidents";
import InvestigationsPage from "./pages/Investigations";
import InfectionDashboard from "./pages/InfectionDashboard";
import SupplyChain from "./pages/SupplyChain";
import SupplyChainManage from "./pages/SupplyChainManage";
import SupplyChainDetail from "./pages/SupplyChainDetail";
import SysMessageGate from "./components/SysMessageGate";
export default function App() {
  // Read once on mount; if you need live updates, lift this into context.
  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
const location = useLocation();
  return (
    <>
    <SysMessageGate />
    <Routes>
      {/* Root: show Login if no token, otherwise GlobalSearch */}
      <Route path="/" element={token ? <InfectionDashboard /> : <LoginPage />} />

      {/* Public auth routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signin" element={<LoginPage />} />
      <Route path="/recover" element={<Recover />} />
      <Route path="/signup" element={<Register />} />
      <Route path="/register" element={<Register />} />
      <Route path="/contact" element={<ContactPanel />} />

      {/* Protected routes */}
      <Route
        path="/search"
        element={
          <ProtectedRoute>
            <GlobalSearch />
          </ProtectedRoute>
        }
      />
      <Route
        path="/global-search"
        element={
          <ProtectedRoute>
            <GlobalSearch />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      {/* Deep-link form: /dashboard/<domain> auto-scopes the page so refreshes
          + sharable links keep the selected vendor loaded. */}
      <Route
        path="/dashboard/:domain"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

            <Route
        path="/global-stats"
        element={
          <ProtectedRoute>
            <InfectionDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/saved-incidents"
        element={
          <ProtectedRoute>
            <SavedIncidents />
          </ProtectedRoute>
        }
      />

<Route
      path="/investigations"
      element={
        <ProtectedRoute>
          {/* Adding the key={location.search} is the magic fix.
            Every time the ?query= change, the key changes, 
            and React forces a fresh remount.
          */}
          <InvestigationsPage key={location.search} />
        </ProtectedRoute>
      }
    />
      <Route
        path="/watchlist-events"
        element={
          <ProtectedRoute>
            <WatchlistEvents key="events" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/brand-protection"
        element={
          <ProtectedRoute>
            <WatchlistEvents key="brand" mode="brand" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supply-chain"
        element={
          <ProtectedRoute>
            <SupplyChain />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supply-chain/manage"
        element={
          <ProtectedRoute>
            <SupplyChainManage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supply-chain/:domain"
        element={
          <ProtectedRoute>
            <SupplyChainDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/watchlists"
        element={
          <ProtectedRoute>
            <Watchlists />
          </ProtectedRoute>
        }
      />
      <Route
        path="/threat-feeds"
        element={
          <ProtectedRoute>
            <IntelPosts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/organization-settings"
        element={
          <ProtectedRoute>
            <Organizations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/webhooks"
        element={
          <ProtectedRoute>
            <Webhooks />
          </ProtectedRoute>
        }
      />
      <Route
        path="/upgrades"
        element={
          <ProtectedRoute>
            <Upgrades />
          </ProtectedRoute>
        }
      />

      {/* Optional: catch-all to login or home */}
      <Route path="*" element={<Navigate to={token ? "/" : "/login"} replace />} />
    </Routes>
    </>
  );
}
